import { ReactNode } from "react";
import styles from "./styles.module.scss";

interface ComparisonBarData {
  expectationStr?: string;
  scale: number;
  result: number;
  leftLabel?: string;
  rightLabel?: string;
}

interface ComparisonBarProps extends ComparisonBarData {
  className?: string;
  reportType?: string;
}

const ComparisonBar = ({
  result,
  className,
  expectationStr,
  leftLabel,
  rightLabel,
  scale,
  reportType,
}: ComparisonBarProps) => {
  const getColor = (value: number) => {
    let res = "";
    if (value >= 90) res = "green";
    else if (value >= 70) res = "blue";
    else if (value >= 50) res = "orange";
    else res = "red";

    return res;
  };

  const scaledResult =
    result > scale ? 100 : Math.round((result / scale) * 100);

  return (
    <>
      <div className={styles.container}>
        <div className={`${styles.comparisonBar} ${className}`}>
          <div
            style={{ width: `${scaledResult}%` }}
            className={`${styles.comparisonBar__bar} ${
              styles[`bg-${getColor(scaledResult)}`]
            }`}
          ></div>
          <div className={styles.comparisonBar__bar__white}></div>
        </div>
        <div className={styles.info}>
          <div
            className={`${styles.info__item} ${styles[getColor(scaledResult)]}`}
          >
            <p className={styles.info__item__txt1}>{result}%</p>
            <p className={styles.info__item__txt2}>
              {leftLabel ?? "Candidate’s Result"}
            </p>
          </div>
          {reportType === "observative" ? null : (
            <div className={styles.info__item}>
              <p className={styles.info__item__txt1}>{expectationStr}</p>
              <p className={styles.info__item__txt2}>
                {rightLabel ?? "Expectation"}
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export interface ComparisonData extends ComparisonBarData {
  title: string;
  description?: string | ReactNode;
  body?: ReactNode;
}

interface ComparisonProps {
  data: ComparisonData[];
  reportType?: string;
}

const Comparisons: React.FC<ComparisonProps> = ({ data, reportType }) => {
  return (
    <div className={styles.comparison}>
      {data.map((item) => (
        <div className={styles.comparison__body}>
          <p className={styles.comparison__body__title}>{item.title}</p>
          <ComparisonBar {...item} reportType={reportType} />
          {item.description ? (
            <p className={styles.comparison__body__description}>
              {item.description}
            </p>
          ) : (
            ""
          )}
          {item.body}
        </div>
      ))}
    </div>
  );
};

export { ComparisonBar, Comparisons };
